import { CircularProgress, IconButton } from '@mui/material';
import { styled as MuiStyled } from '@mui/material/styles';
import useLayoutTypeContext from 'framework/base/hooks/useLayoutTypeContext';
import React from 'react';

const CustomIconButton = MuiStyled(IconButton)`
    color: ${(props) =>
      props.disabled
        ? props.theme.icon.disable.color
        : props.theme.icon.grey.color} !important;
    padding: ${(props) =>
      (props.layouttype === 'mobile' || props.noPadding) && 0};
`;

const AryLoadingIconButton = ({
  loading,
  children,
  progressSize,
  width,
  display = 'inline-flex',
  noPadding,
  ...others
}) => {
  const layoutType = useLayoutTypeContext();

  const content = () => {
    if (!loading) {
      return (
        <CustomIconButton
          layouttype={layoutType}
          noPadding={noPadding}
          tabIndex={-1}
          {...others}
        >
          {children}
        </CustomIconButton>
      );
    }
    return <CircularProgress size={progressSize || 20} />;
  };

  if (noPadding) {
    return content;
  }

  return (
    <div
      style={{
        display,
        width:
          width ||
          (layoutType === 'mobile'
            ? '20px'
            : layoutType === 'tablet'
            ? '30px'
            : '1.875rem'),
        height:
          layoutType === 'mobile'
            ? '20px'
            : layoutType === 'tablet'
            ? '22.5px'
            : '1.5rem',
        alignItems: 'center',
        justifyContent: 'center'
      }}
    >
      {content()}
    </div>
  );
};

export default AryLoadingIconButton;
